<template>
    <v-container fluid class="container-full-bg-gray">
    <div>
        <v-dialog v-model="show_dialog" max-width="800">
            <v-card>
                <v-row>
                    &nbsp
                </v-row>
                <v-row>
                    <div>
                        &nbsp &nbsp {{dialog_msg}}
                    </div>
                </v-row>
                <v-row>
                    &nbsp
                </v-row>
                <v-row>
                    <v-col cols="1">
                    </v-col>
                    <v-col cols="3">
                        <v-btn @click="cancel_dialog">
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="4">
                    </v-col>
                    <v-col cols="3">
                        <v-btn @click="accept_dialog" style="background-color:rgba(156, 121, 171)">
                            Aceptar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
            
        </v-dialog>
        <div v-if="(session_information && session_information.username != userData.username)">
            <br>
            <div style="font-size:5vh">
                Estado funcionalidades para<b> {{userData.username}}</b>
                <br>
            </div>
            <div style="font-size:2vh">
                <v-row>
                    <v-col cols="1">
                        <v-row>
                        &nbsp &nbsp &nbsp
                        <div :style="{ 'background-color': get_color['available'], 'width':'20%','min-height': '100 %','margin-left':'0.1vh' }">
                            &nbsp
                        </div>
                        &nbsp Activa &nbsp
                        
                        </v-row>
                    </v-col>
                    <v-col cols="2" style="margin-left:3vh">
                        <v-row>
                            &nbsp &nbsp
                            <div :style="{ 'background-color': get_color['need_perm'], 'width':'10%','min-height': '100 %','margin-left':'0.1vh' }">
                                &nbsp
                            </div>
                            &nbsp Necesita permiso &nbsp
                        
                        </v-row>
                    </v-col>
                    <v-col cols="2">
                        <v-row>
                            <div :style="{ 'background-color': get_color['need_update'], 'width':'10%','min-height': '100 %','margin-left':'0.1vh' }">
                                &nbsp
                            </div>
                            &nbsp Necesita Actualización &nbsp
                        
                        </v-row>
                    </v-col>
                    <v-col cols="2" style="margin-left:3vh">
                        <v-row>
                        <div :style="{ 'background-color': get_color['not_available'], 'width':'10%','min-height': '100 %','margin-left':'0.1vh' }">
                            &nbsp
                        </div>
                        &nbsp No disponible &nbsp
                        </v-row>
                    </v-col>
                </v-row>
            </div>
            <br>
            <v-row style="margin-left:2vh">
                    <v-icon style="font-size:6vh" >mdi-feature-search-outline</v-icon>
                    <v-text-field 
                    label="Buscar..."
                    v-model="search" 
                    class="ml-2 pl-1"
                    no-gutters
                    style="max-width:13%"
                    ></v-text-field>
            </v-row>
            <br>
            <v-data-table :headers="headers" :items="filt_items" :loading="loading" style="line-height:3.5" :sortable="false" >
                <template v-slot:item=" {item} ">
                    <tr>
                        <td >
                            {{item['feature']}}        
                        </td>
                        <td >
                            {{item['group']['name']}}        
                        </td>
                        <td v-for="h in headers.slice(2)" class="pa-0">
                            <div v-if="item[h.value]!='need_update_and_perm'" 
                                :style="{ 'background-color': get_color[item[h.value]], 'min-height': '100 %','margin-left':'0.1vh' }"
                                @click="click(item,h)">
                                &nbsp
                            </div>
                            <div v-else  @click="click(item,h,'p')" :style="{ 'background-color': get_color['need_perm'], 'min-height': '100 %','margin-left':'0.1vh','z-index':'2' } ">
                                <div @click.stop="click(item,h,'u')" 
                                    :style="{ 'background-color': get_color['need_update'], 'min-height': '100 %','width':'50%','z-index':'5' }">
                                    &nbsp
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    <div v-else-if="userData.is_staff">
        <br>
        <div style="font-size:5vh">
            Estadísticas generales funcionalidades (<b> {{utils.total_users}}</b> usuarios)
            <br>
        </div>
        <br>
        <v-row>
            <v-col cols="2">
                <div  style="font-size:3vh">
                    Owners : <b>{{utils.owner_users}}</b>
                </div>
            </v-col>
            <v-col cols="2">
                <div  style="font-size:3vh">
                    Rest : <b>{{utils.ro_users}}</b>
                </div>
            </v-col>
        </v-row>
        <v-row style="margin-left:2vh">
                <v-icon style="font-size:6vh" >mdi-feature-search-outline</v-icon>
                <v-text-field 
                label="Buscar..."
                v-model="search" 
                class="ml-2 pl-1"
                no-gutters
                style="max-width:13%"
                ></v-text-field>
        </v-row>
        <br>
        <v-data-table :headers="headers" :items="filt_items" :loading="loading" style="line-height:3.5" :sortable="false"  >
             <template v-slot:item=" {item} ">
                <tr>
                    <td >
                        {{item['feature']}}        
                    </td>
                    <td >
                        {{item['group']}}        
                    </td>
                    <td class="pa-0">
                            <div :style="{ 'background-color': 'rgba(156, 121, 171,'+ (get_opacity(item['count'])).toString() +')', 'min-height': '100 %','margin-left':'0.1vh'}">
                                <div v-if="item['count'] < 0.8*utils.owner_users">
                                &nbsp &nbsp &nbsp {{item['count']}}
                                </div>
                                <div v-else>
                                    &nbsp &nbsp &nbsp <b>{{item['count']}}</b>
                                </div>
                            </div>
                        </td>
                        <td v-for="h in headers.slice(3)" class="pa-0">
                                <div v-if="item[h.value]==true" 
                                    :style="{ 'background-color': get_color['available'], 'min-height': '100 %','margin-left':'0.1vh' }">
                                    &nbsp
                                </div>
                                <div v-else-if="item[h.value]==false" 
                                    :style="{ 'background-color': get_color['not_available'], 'min-height': '100 %','margin-left':'0.1vh' }">
                                    &nbsp
                                </div>
                                <div v-else 
                                    :style="{ 'background-color': get_color['need_update'], 'min-height': '100 %','margin-left':'0.1vh' }">
                                    &nbsp {{item[h.value]}}
                                </div>
                                
                        </td>
                </tr>
            </template>
         </v-data-table>
    </div>
    </div>
    </v-container>
</template>

<script>
import { mapActions, mapGetters,mapState } from "vuex";
import { mapFields } from 'vuex-map-fields';
import { client } from "@/api/client";

export default {
    components: {
    },
    computed: {
        ...mapState([
            'session_information'
            ]),
        ...mapGetters({
            userData: 'me/userData',
        }),
        get_color(){
            return {'available':'#A2C892',
                    'not_available':'#f24545',
                    'need_perm':'#efa358',
                    'need_update':'#6fa8dc',
                    'need_update_and_perm':'yellow',
                    'error':'black'}

        },
        filt_items(){
            if(this.search){
                let new_items = []
                for(let i in this.items){
                    let item = this.items[i]
                    let name = item['group']
                    try{
                        if(item['group']['name']){
                            name = item['group']['name']
                        }
                    }catch(e){

                    }

                    if(item['feature'].includes(this.search.toLowerCase()) || name.toLowerCase().includes(this.search.toLowerCase())){
                        new_items.push(item)
                    }
                }
                return new_items
            }
            else{
                return this.items;
            }
        }
    },
    data() {
        return {
            items:[],
            headers:[],
            loading:false,
            search:"",
            utils : {},
            show_dialog:false,
            group:'',
            action:'',
            dialog_msg:'',
        }
    },
    methods: {
        click(item,h,d=null){
            let group = item['group']
            if(item[h.value] == 'available'){
                if(group['id']){
                    this.dialog_msg = 'Quitar permiso "'+group['name']+'" a '+ this.userData.username
                    this.action = 'remove_perm'
                    this.group = group['id']
                    this.show_dialog = true
                }
                else{
                    this.dialog_msg = 'Este permiso no tiene grupo early adopters'
                    this.show_dialog = true
                }
            }
            else if(item[h.value] == 'need_perm'){
                if(group['id']){
                    this.dialog_msg = 'Dar permiso "'+group['name']+'" a '+ this.userData.username
                    this.action = 'give_perm'
                    this.group = group['id']
                    this.show_dialog = true
                }
                else{
                    this.dialog_msg = 'Este permiso no tiene grupo early adopters'
                    this.show_dialog = true
                }
            }
            else if(item[h.value] == 'need_update'){
                console.log('klak updating',this.userData.username)
            }
            else if(item[h.value] == 'need_update_and_perm'){
                if(d=='u'){
                    console.log('klak updating',this.userData.username)
                }
                else if(d=='p'){
                    if(group['id']){
                        this.dialog_msg = 'Dar permiso "'+group.name+'" a '+ this.userData.username
                        this.action = 'give_perm'
                        this.group = group['id']
                        this.show_dialog = true
                    }
                    else{
                        this.dialog_msg = 'No se puede modificar grupo '+group
                        this.show_dialog = true
                    }
                }
            }
            
        },
        accept_dialog(){
            this.show_dialog = false
            if(this.action == 'give_perm'){
                this.give_perm(this.feat)
            }
            else if(this.action = 'remove_perm'){
                this.remove_perm(this.feat)
            }
        },
        cancel_dialog(){
            this.show_dialog = false
            this.dialog_msg = ''
            this.action = ''
            this.feat = ''
        },
        give_perm(feat){
            let url = 'add_user_to_group/'
            console.log(this.userData)
            client.patch(url,{'user':this.userData.user,'group':this.group}).then((res) => {
                    if(res['ok']=='ko'){
                        this.dialog_msg = 'Algo ha ido mal.' + this.group.id.toString()
                        this.show_dialog = true
                    }
                    this.get_items()
                }).catch(err => {
                    this.dialog_msg = 'Algo ha ido mal.'+err.toString()
                    this.show_dialog = true
                    console.debug(err);
                });
        },
        remove_perm(feat){
            let url = 'remove_user_from_group/'
            console.log(this.userData)
            client.patch(url,{'user':this.userData.user,'group':this.group}).then((res) => {
                    if(res['ok']=='ko'){
                        this.dialog_msg = 'Algo ha ido mal.'
                        this.show_dialog = true
                    }
                    this.get_items()
                }).catch(err => {
                    this.dialog_msg = 'Algo ha ido mal.'
                    this.show_dialog = true
                    console.debug(err);
                });
        },
        get_items(){
            this.loading = true
            let url = 'get_features_table/'
            if(this.userData.is_staff){
                url = 'get_features_table_staff/'
            }
            client.get(url).then(response => {
                    console.log(response.data)
                    this.items = response.data['items'];
                    this.headers = response.data['headers'];
                    this.utils = response.data['utils'];
                    this.loading=false
                }).catch(err => {
                    console.debug(err);
                });
        },
        get_opacity(count){
            if (count==0){
                return 0
            }
            else{
                return 0.3+(count/this.utils.owner_users)*0.7
            }
        },
        
    },
    mounted(){
        this.get_items()
    }
}
</script>
            
